import React, { useState } from 'react';
import { Radar, Database, FileSignature, Plug, Handshake, Scale } from 'lucide-react';
import { BankApiDiscovery } from './bank-partnerships/BankApiDiscovery';
import { BankApiDirectory } from './bank-partnerships/BankApiDirectory';
import { BankAccessApprovals } from './bank-partnerships/BankAccessApprovals';
import { BankGatewayTransmit } from './bank-partnerships/BankGatewayTransmit';
import { BankReconciliation } from './bank-partnerships/BankReconciliation';
import { BankPartnershipPanel } from './BankPartnershipPanel';

const SUBTABS = [
  { id: 'discovery', label: 'Discovery', icon: <Radar className="w-4 h-4" /> },
  { id: 'directory', label: 'Directory & Endpoints', icon: <Database className="w-4 h-4" /> },
  { id: 'access', label: 'Access & Approvals', icon: <FileSignature className="w-4 h-4" /> },
  { id: 'gateway', label: 'Gateway & Transmit', icon: <Plug className="w-4 h-4" /> },
  { id: 'reconciliation', label: 'Reconciliation', icon: <Scale className="w-4 h-4" /> },
  { id: 'simple', label: 'Quick Partnership', icon: <Handshake className="w-4 h-4" /> },
];

export const BankConnectivityHub = ({ token }) => {
  const [sub, setSub] = useState('discovery');
  const [dirKey, setDirKey] = useState(0);

  return (
    <div className="space-y-4" data-testid="bank-connectivity-hub">
      <div className="flex flex-wrap gap-2">
        {SUBTABS.map(t => (
          <button key={t.id} onClick={() => setSub(t.id)} data-testid={`connectivity-subtab-${t.id}`}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${sub === t.id ? 'bg-emerald-600 text-white' : 'text-slate-400 hover:text-white hover:bg-slate-800'}`}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>
      {sub === 'discovery' && <BankApiDiscovery token={token} onRegistered={() => setDirKey(k => k + 1)} />}
      {sub === 'directory' && <BankApiDirectory token={token} refreshKey={dirKey} />}
      {sub === 'access' && <BankAccessApprovals token={token} />}
      {sub === 'gateway' && <BankGatewayTransmit token={token} />}
      {sub === 'reconciliation' && <BankReconciliation token={token} />}
      {sub === 'simple' && <BankPartnershipPanel token={token} />}
    </div>
  );
};
